import { Stack, Typography } from '@mui/material';
import { useCreateMerchantMutation } from 'api/client-domain/client-domain';
import { useUpdateLoyaltySpecsMutation } from 'api/loyalty-domain/loyalty-domain';
import LoyaltySpecForm from 'components/forms/loyalty-spec-form/loyalty-spec-form.component';
import WorkspaceForm from 'components/forms/workspace-form/workspace-form.component';
import { useCreateWorkspaceForm } from 'components/forms/workspace-form/workspace-form.hooks';
import { useTranslation } from 'react-i18next';
import FormDrawer from '../form-drawer/form-drawer.component';
import { IncDrawerType } from '../inc-drawer/inc-drawer.component';
import { useSnackbar } from 'notistack';
import { useCreateMerchantSettingsMutation } from 'api/ordering-service/ordering-service';

const CreateWorkspaceDrawer = (props: IncDrawerType<{}>) => {
  const { t } = useTranslation();
  const { form } = useCreateWorkspaceForm();
  const [updateLoyaltySpecs, { isLoading: isUpdateLoyaltySpecsLoading }] =
    useUpdateLoyaltySpecsMutation();
  const [createMerchant, { isLoading: isCreateMerchantLoading }] =
    useCreateMerchantMutation();
  const [
    createMerchantSettings,
    { isLoading: isCreateMerchantSettingsLoading },
  ] = useCreateMerchantSettingsMutation();
  const { enqueueSnackbar } = useSnackbar();

  const submit = async data => {
    try {
      const merchantResponse = await createMerchant(data.workspace).unwrap();
      await updateLoyaltySpecs({
        data: data.loyalty,
        merchantId: merchantResponse.merchantId,
      }).unwrap();
      await createMerchantSettings({
        merchantId: merchantResponse.merchantId,
        orderProcessingConfig: {
          orderGatewayName: 'incentivio-order',
          orderProcessingStrategy: 'INCENTIVIO_ORDER',
          paymentGatewayName: 'incentivio-conpay-spreedly',
          paymentIDGenerationStrategy: 'UUID',
          consolidateMultipleDiscounts: false,
          realTimeLoyaltyProcessing: false,
        },
      }).unwrap();

      props.close();
      form.reset();

      enqueueSnackbar(t('drawer.CreateWorkspaceDrawer.success'), {
        severity: 'success',
      });
    } catch (_e) {}
  };

  const cancel = _e => {
    props.close();
    form.reset();
  };

  return (
    <FormDrawer
      open={props.isOpen}
      title={t('drawer.CreateWorkspaceDrawer.title')}
      data-testid="CreateWorkspaceDrawer"
      onValid={submit}
      onClose={cancel}
      cancel={cancel}
      formMethods={form}
      isLoading={
        isUpdateLoyaltySpecsLoading ||
        isCreateMerchantLoading ||
        isCreateMerchantSettingsLoading
      }
    >
      <Stack spacing={2} pt={2}>
        <WorkspaceForm prefix="workspace" compact />

        <Typography component="h2" variant="h4">
          {t('page.settings.loyalty-specs.title')}
        </Typography>
        <LoyaltySpecForm prefix="loyalty" />
      </Stack>
    </FormDrawer>
  );
};
export default CreateWorkspaceDrawer;
